export class UnidadAdministrativa {


    idUnidad: number;

    idAcademico: number;

    idTalentoHumano: number;

    nombre: string;

    correo: string;

    idPadre: number;

    estaActivo: boolean;

    usuarioCreacion: string;

    fechaCreacion: Date;

    usuarioAcualizacion: string;

    fechaActualizacion: Date;

    unidadPadre: UnidadAdministrativa;

    hijos: UnidadAdministrativa[] = [];


    static clonar(objectToCopy: UnidadAdministrativa): UnidadAdministrativa{
		return (JSON.parse(JSON.stringify(objectToCopy)));
	}
	
	clonando(): UnidadAdministrativa{
		return (JSON.parse(JSON.stringify(this)));
	}


}
